import {
  FOOTER_PAGE_TYPE,
  FOOTER_PAGE_TYPE_BY_ROUTE_PREFIX,
  TFooterPageType,
} from '@helpers/constants/footerSections';
import { HOME_AB_TEST_PATH } from '@helpers/constants/home-ab-test';
import { TFooterSectionsContent } from '@services/datocms/common/getFooter';
import { TSections } from '@services/datocms/visual-blocks';

export const getFooterPageType = (route: string): Nullable<TFooterPageType> => {
  if (route === '/' || route === HOME_AB_TEST_PATH) {
    return FOOTER_PAGE_TYPE.HOME;
  }

  const matchedRoute = FOOTER_PAGE_TYPE_BY_ROUTE_PREFIX.find(([prefix]) =>
    route.startsWith(prefix)
  );

  return matchedRoute ? matchedRoute[1] : null;
};

export const resolveFooterSections = (
  sections: Nullable<TFooterSectionsContent[]>,
  pageType: Nullable<TFooterPageType>
): Nullable<TSections> => {
  if (!sections?.length || !pageType) {
    return null;
  }

  const usableConfigs = sections.filter(
    ({ active, sectionsContent }) => active && !!sectionsContent?.sections?.length
  );
  const matchedConfig =
    usableConfigs.find(config => config.pageType === pageType) ??
    usableConfigs.find(({ pageType: type }) => type === FOOTER_PAGE_TYPE.GLOBAL);

  return matchedConfig?.sectionsContent?.sections ?? null;
};
